import React from "react";
import { FaEnvelope, FaHeadset, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const SUPPORT_EMAIL = "support@tumma.co";
const SUPPORT_PHONE = "+91 814 225 1234";

function TenantSupport() {
  return (
    <div className="cportal-page">
      <div className="cportal-page-head">
        <div>
          <h1>Support</h1>
        </div>
      </div>

      <div className="cportal-support-card">
        <div className="cportal-support-card-head">
          <div className="cportal-support-card-icon" aria-hidden="true">
            <FaHeadset />
          </div>
          <h2>Contact Support</h2>
        </div>
        <p>
          Reach our team for account access, billing questions, or product help.
          We typically respond within one business day.
        </p>
        <div className="cportal-support-contacts">
          <a className="cportal-support-contact" href={`mailto:${SUPPORT_EMAIL}`}>
            <FaEnvelope aria-hidden="true" />
            <span>{SUPPORT_EMAIL}</span>
          </a>
          <a className="cportal-support-contact" href={`tel:${SUPPORT_PHONE.replace(/\s/g, "")}`}>
            <FaPhoneAlt aria-hidden="true" />
            <span>{SUPPORT_PHONE}</span>
          </a>
          <a
            className="cportal-support-contact"
            href={`https://wa.me/${SUPPORT_PHONE.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp aria-hidden="true" />
            <span>Chat on WhatsApp Business</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default TenantSupport;
